// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"255":"d0d1ca58","387":"3b8a7f82","616":"8fdaf033","685":"0a0dcc73","693":"bab06f6c","760":"3dcf0e4b","769":"e2db0e92","810":"07c2fa62"}[chunkId] + ".chunk.js";
};